// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:hdZSlL */\n.hlB1t{align-items:center;background-color:var(--audio-background-highlight);border:1px solid var(--audio-stroke-default);border-radius:var(--audio-radius-2);display:none;gap:var(--audio-spacing-16);justify-content:space-between;padding:var(--audio-spacing-16)}@media (min-width:1280px){.hlB1t{display:flex}}._33heU{grid-gap:var(--audio-spacing-8);display:grid;gap:var(--audio-spacing-8)}.mRVMU{aspect-ratio:232/62;display:block;height:1.875rem;width:auto}._64SDJ{color:var(--audio-content-primary);font-size:var(--audio-font-size-20);line-height:var(--audio-line-height-24);margin:0}.lVLGH{flex-shrink:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner": "hlB1t",
	"info": "_33heU",
	"audacityLockup": "mRVMU",
	"label": "_64SDJ",
	"cta": "lVLGH"
};
export default ___CSS_LOADER_EXPORT___;
